export default {
  getInventarioTableHeaders(state) {
    return state.inventarioTableHeaders;
  },
  getInventarioTableItems(state) {
    return state.inventarioTableItems;
  },
  getPrecisaoInventario(state) {
    return state.precisaoInventario;
  },
  getInventariosRealizados(state) {
    return state.inventariosRealizados;
  },
  getHistoricoProdutosInventario(state) {
    return state.historicoProdutosInventario;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
